import actionCreatorsDocumentObjectsMap from "Areas/Documents/graph/redux/actionCreators.documentObjectsMap";
import NodeSource from "Areas/SharedFeatures/types/nodeSource";
import { GEOSPATIAL_LAT_LON_DELIMITER } from "Common/componentUtils/constants";
import { uuid7 } from "Common/uuid7";
import head from "lodash/head";
import compact from "lodash/compact";
import join from "lodash/join";
export const createNodeSourceCoordinate = ({ mapGeometry, documentObjects }) => {
    const { DocumentObjectId, attributes } = actionCreatorsDocumentObjectsMap.coordinate;
    const point = head(mapGeometry.Points);
    return new NodeSource(mapGeometry.Id || uuid7(), documentObjects[DocumentObjectId], undefined, undefined, compact([
        {
            Key: attributes.latitude,
            Value: point === null || point === void 0 ? void 0 : point[0].toString()
        },
        {
            Key: attributes.longitude,
            Value: point === null || point === void 0 ? void 0 : point[1].toString()
        },
        {
            Key: attributes.geotag,
            Value: join(point, GEOSPATIAL_LAT_LON_DELIMITER)
        }
    ]), null, mapGeometry.Created, mapGeometry.Description, mapGeometry.Color);
};
